import { toast } from 'react-toastify';
import { generatePDF as generatePDFService } from '@features/invoices/services/pdfService';
import { generateChargesPDF as generateChargesPDFService } from '@features/invoices/services/pdfServiceCharges';
import { isChargeBasedInvoiceType } from '@features/invoices/services/invoiceType';

export default function usePdfGeneration() {
  const generatePDF = async (invoice?: any, contacts?: any) => {
    try {
      if (isChargeBasedInvoiceType(invoice?.invoice_type)) {
        await generateChargesPDFService(invoice, contacts);
      } else {
        await generatePDFService(invoice, contacts);
      }
      toast.info('Generated PDF!', { autoClose: 2000, toastId: `generate-pdf` });
    } catch (err) {
      toast.error('Failed to generate PDF!', { toastId: `generate-pdf-error` });
      console.error('Failed to generate PDF:', err);
    }
  };

  return {
    generatePDF,
  };
}
